var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect5, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.486328,
    y: 0.285156,
    width: 350,
    height: 233,
    fill: "#67C7BB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 225.586,
    y: 142.688,
    width: 4.59592,
    height: 19.8783,
    rx: 2.29796,
    transform: "rotate(34.148 225.586 142.688)",
    fill: "#FFECF4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.59592,
    height: 20.5695,
    rx: 2.29796,
    transform: "matrix(-0.827591 0.561332 0.561332 0.827591 300.875 142.117)",
    fill: "#FFECF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 219.588,
    y: 151.363,
    width: 87.6471,
    height: 4.59592,
    rx: 2.29796,
    fill: "#FFECF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.179 151.555H227.485C226.995 151.555 226.598 151.952 226.598 152.442C226.598 152.709 226.715 152.965 226.929 153.125C227.747 153.74 228.617 154.086 231.562 154.086C234.26 154.086 276.637 154.072 297.488 154.086C298.832 154.086 299.524 153.74 300.007 153.215C300.159 153.05 300.227 152.827 300.227 152.603C300.227 152.024 299.757 151.555 299.179 151.555Z",
    fill: "#ECCDDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.579 83.8109C226.189 76.5595 232.252 70.9844 239.529 70.9844H287.32C294.597 70.9844 300.661 76.5595 301.271 83.8109L305.81 137.771C306.497 145.938 300.054 152.945 291.859 152.945H234.991C226.796 152.945 220.353 145.937 221.04 137.771L225.579 83.8109Z",
    fill: "#CF8CA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.322 70.9844H247.037L305.303 131.609L301.273 83.8082C300.662 76.5579 294.598 70.9844 287.322 70.9844Z",
    fill: "#B56788"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.979 88.0294C233.211 84.8963 235.82 82.4727 238.962 82.4727H287.888C291.03 82.4727 293.64 84.8963 293.872 88.0294L296.047 117.393C296.305 120.871 293.552 123.836 290.063 123.836H236.787C233.299 123.836 230.546 120.871 230.803 117.393L232.979 88.0294Z",
    fill: "#F0B6CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.884 82.4727H258.076L294.45 120.072C295.1 120.744 296.235 120.236 296.166 119.304L293.868 88.0329C293.638 84.8982 291.027 82.4727 287.884 82.4727Z",
    fill: "#D597B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.721 123.836L241.465 82.4727H247.897L259.273 123.836H252.721Z",
    fill: "#F7CADD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.799 123.836L252.423 82.4727H254.27L265.467 123.836H263.799Z",
    fill: "#F7CADD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 248.871,
    y: 74.2188,
    width: 29.1075,
    height: 6.05907,
    rx: 1,
    fill: "#B56788"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277.978 79.2778V75.2188C277.978 74.6665 277.531 74.2188 276.978 74.2188H250.176L255.71 79.9711C255.898 80.1671 256.158 80.2778 256.43 80.2778H276.978C277.531 80.2778 277.978 79.8301 277.978 79.2778Z",
    fill: "#8E385D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.881 139.683L221.384 133.66H305.489L305.989 139.683H220.881Z",
    fill: "#B56788"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 290.605,
    cy: 136.673,
    r: 5.91919,
    fill: "#CF8CA8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.245,
    cy: 136.673,
    r: 5.91919,
    fill: "#CF8CA8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.605,
    cy: 136.673,
    r: 4.6221,
    fill: "#8E385D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.245,
    cy: 136.673,
    r: 4.6221,
    fill: "#8E385D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.604,
    cy: 136.932,
    r: 4.36178,
    fill: "#F0B6CE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.245,
    cy: 136.932,
    r: 4.36178,
    fill: "#F0B6CE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.137 78.8958V75.5469H259.45C260.211 75.5469 260.648 76.0164 260.648 76.6755C260.648 77.3439 260.204 77.8042 259.432 77.8042H258.831V78.8958H258.137ZM258.831 77.2445H259.321C259.733 77.2445 259.934 77.0132 259.931 76.6755C259.934 76.3425 259.733 76.1181 259.321 76.1158H258.831V77.2445Z",
    fill: "#D597B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.319 78.9375C261.102 78.9375 260.926 78.764 260.931 78.5489C260.926 78.3361 261.102 78.1627 261.319 78.165C261.525 78.1627 261.703 78.3361 261.703 78.5489C261.703 78.764 261.525 78.9375 261.319 78.9375Z",
    fill: "#D597B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262.267 78.8958V75.5469H263.581C264.342 75.5469 264.779 76.0164 264.779 76.6755C264.779 77.3439 264.335 77.8042 263.563 77.8042H262.961V78.8958H262.267ZM262.961 77.2445H263.452C263.863 77.2445 264.064 77.0132 264.062 76.6755C264.064 76.3425 263.863 76.1181 263.452 76.1158H262.961V77.2445Z",
    fill: "#D597B0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.889 75.5469V78.8958H265.205V75.5469H265.889Z",
    fill: "#D597B0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M267.559 78.9467C266.789 78.9444 266.317 78.4471 266.319 77.6515C266.317 76.8767 266.796 76.3517 267.531 76.3517C268.191 76.3517 268.711 76.768 268.711 77.6238V77.8181H266.995C266.995 78.1974 267.219 78.431 267.573 78.4333C267.807 78.431 267.973 78.3292 268.04 78.1789H268.692C268.595 78.6437 268.179 78.9444 267.559 78.9467ZM266.995 77.3879H268.063C268.061 77.0826 267.851 76.8629 267.545 76.8652C267.231 76.8629 267.009 77.0988 266.995 77.3879Z",
    fill: "#D597B0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport01);
export default __webpack_public_path__ + "static/media/transport_01.09e894c55ce31c81dcd955b85622599e.svg";
export { ForwardRef as ReactComponent };